$(function(){
  if(!$('.add_set.favorite').length) return;

  $('body').on('click', '.report_wrapper .title', function(){
    $('.report_wrapper').removeClass('active');
    $(this).closest('.report_wrapper').addClass('active');
  });
});
